;(function () {
    const initSplitSlider = () => {
        const sections = document.querySelectorAll('.product-with-image__section');

        sections.forEach((section) => {
            if (section.classList.contains('slider_started')) return;
            section.classList.add('slider_started');

            const container = section.querySelector('.product-with-image');
            const isAutoplay = container.dataset.autoplay === 'true';
            const stopOnHover = container.dataset.stopAutoplay === 'true';
            const speed = parseFloat(container.dataset.speed) * 1000;
            const delay = parseFloat(container.dataset.delay) * 1000;

            // 1. Initialize the Background Image Slider
            const imageSwiper = new Swiper(section.querySelector('.product-with-image__image-slider__box'), {
                slidesPerView: 1,
                loop: true,
                effect: 'fade', // Smooth transition for background
                fadeEffect: { crossFade: true },
                speed: speed,
                allowTouchMove: false // Image side follows the product side
            });

            // 2. Initialize the Product Slider
            const productSwiper = new Swiper(section.querySelector('.product-with-image__product-swiper'), {
                slidesPerView: 1,
                loop: true,
                speed: speed,
                spaceBetween: 24,
                autoplay: isAutoplay ? {
                    delay: delay,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: stopOnHover
                } : false,
                pagination: {
                    el: section.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                on: {
                    // This syncs the background image with the active product slide
                    slideChange: function () {
                        imageSwiper.slideToLoop(this.realIndex);
                    }
                }
            });
        });
    };

    document.addEventListener('DOMContentLoaded', initSplitSlider);
    document.addEventListener('shopify:section:load', initSplitSlider);
})();